export const AUTH_MODAL_OPEN = 'AUTH_MODAL_OPEN';
export const AUTH_MODAL_CLOSE = 'AUTH_MODAL_CLOSE';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const SIGN_OUT = 'SIGN_OUT';
